export const Marquee = ({ items }) => (
  <div className="relative flex overflow-hidden border-y border-white/10 bg-ink-800 py-5" data-testid="marquee">
    <div className="marquee-track animate-marquee">
      {[...items, ...items].map((it, i) => (
        <span key={i} className="mx-8 flex items-center gap-8 text-sm font-mono uppercase tracking-[0.2em] text-chrome-mid whitespace-nowrap">
          {it}
          <span className="h-1.5 w-1.5 rounded-full bg-signature" />
        </span>
      ))}
    </div>
  </div>
);
